import { PERCEPTION_CONTENT } from './perceptionContent';
const armBannerContent = {
  content: _ref => {
    let {
      tSuite
    } = _ref;
    return tSuite(PERCEPTION_CONTENT.businessManager.banner);
  },
  tooltip: undefined
};
export const PERCEPTION_VOUCHER_BANNER = {
  'free-plan': armBannerContent,
  'premium-with-voucher': armBannerContent
};
//# sourceMappingURL=perceptionVoucherBanner.js.map